import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/pagination";

export default function initHeroSwiper() {
  const swiperContainers = document.querySelectorAll(".hero-swiper.swiper");

  if (!swiperContainers.length) {
    console.log("No swiper containers found");
    return;
  }

  console.log("Found swiper containers:", swiperContainers.length);

  swiperContainers.forEach((container, index) => {
    const paginationEl = container.querySelector(".swiper-pagination");
    console.log(
      `Initializing swiper ${index + 1}, pagination element:`,
      paginationEl,
    );

    new Swiper(container, {
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      speed: 800,
      loop: true,
      slidesPerGroup: 1,
      spaceBetween: 0,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
}
